var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('b-form-input',{attrs:{"placeholder":"Enter the CategoryName"},model:{value:(_vm.inputvalue),callback:function ($$v) {_vm.inputvalue=$$v},expression:"inputvalue"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }